import Sales from './Sales.jsx';

export default Sales;
